import { render } from "./HeroEditor.vue?vue&type=template&id=2893a35e&scoped=true"
import script from "./HeroEditor.vue?vue&type=script&lang=js"
export * from "./HeroEditor.vue?vue&type=script&lang=js"

import "./HeroEditor.vue?vue&type=style&index=0&id=2893a35e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2893a35e"]])

export default __exports__